import { useRef, useEffect } from "react";

const SOUND_FILES = {
  flame: "/flamesound.mp3",
  yay: "/yay.mp3",
  explosion: "/explosion.mp4",
  saber: "/saber.mp3",
  scream: "/scream.mp3",
  faaah: "/faaah.mp3",
  paper: "/paper.mp3",
  gunshot: "/gunshot.mp3",
  watchasay: "/watchasay.mp3",
  broplease: "/broplease.mp3",
};

export default function useSounds() {
  const soundsRef = useRef({});

  useEffect(() => {
    const sounds = {};
    for (const [key, src] of Object.entries(SOUND_FILES)) {
      const audio = new Audio(src);
      audio.preload = "auto";
      sounds[key] = audio;
    }
    soundsRef.current = sounds;
  }, []);

  const play = (name) => {
    const audio = soundsRef.current[name];
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
  };

  return play;
}
